import { render } from "./WatIcon.vue?vue&type=template&id=954082f4"
import script from "./WatIcon.vue?vue&type=script&lang=js"
export * from "./WatIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__